export enum INPUT_MODE {
  MAKER = 'maker',
  TAKER = 'taker',
}

export enum TradeDirection {
  Input = 'input',
  Output = 'output',
}

export enum RateState {
  IDLE = 'IDLE',
  LOADING = 'LOADING',
  NetworkReason = 'NetworkReason',
  OK = 'OK',
  REFRESH_LOADING = 'REFRESH_LOADING',
}

export enum PROTOCOL_TYPE {
  AMM = 'AMM',
  PMM = 'PMM',
}

export interface GasLimitByProtocols {
  bufferFactor?: number
  pmm?: string
  sushiswap?: string
  uniswap?: string
  'rfq v1'?: string
  rfqv2?: string
}

export type QueryParams = {
  chainId?: string
  toChainId?: string
  inputAddress?: string
  outputAddress?: string
}
